import pagination from '@/helpers/pagination';
import create from './create/model';
import deleteModel from './delete/model';

export default {
    ...pagination('taxList').model,
    create,
    delete: deleteModel,
};
